import type { Editor } from "./canvas";
import type { TLImageShape } from "@tldraw/tlschema";

/** Upgrade only the old generated default; never overwrite a custom name. */
export function editedImageLabels(shape: TLImageShape) {
  if (!shape.meta.aiJob) return null;
  const name = shape.meta.name === "AI alternative";
  const alt = shape.props.altText === "AI alternative";
  if (!name && !alt) return null;
  return {
    id: shape.id,
    type: "image" as const,
    ...(name ? { meta: { ...shape.meta, name: "Edited image" } } : {}),
    ...(alt ? { props: { altText: "Edited image" } } : {}),
  };
}

export function updateLegacyCreativeLabels(editor: Editor) {
  if (editor.getIsReadonly()) return;
  editor.run(
    () => {
      for (const record of editor.store.allRecords()) {
        if (record.typeName !== "shape" || record.type !== "image") continue;
        if (!record.meta.aiJob) continue;
        const update = editedImageLabels(record);
        if (update) editor.updateShape(update);
        const asset =
          record.props.assetId && editor.getAsset(record.props.assetId);
        if (
          asset?.type === "image" &&
          asset.props.name === "AI alternative.png"
        )
          editor.updateAssets([
            { ...asset, props: { ...asset.props, name: "Edited image.png" } },
          ]);
      }
    },
    { history: "ignore", ignoreShapeLock: true },
  );
}
